// Trix 自定义配置 - 添加居中对齐功能
// 使用 tagName + style 的方式，这是 Trix 2.x 支持的正确方式

// 等待 Trix 加载完成后再配置
document.addEventListener('trix-before-initialize', function() {
  // 添加居中对齐作为文本属性
  // 使用 span 标签并通过 style 属性设置居中
  Trix.config.textAttributes.textAlignCenter = {
    tagName: 'span',
    style: { textAlign: 'center' },
    inheritable: true,
    parser: function(element) {
      const style = element.style
      return style && style.textAlign === 'center'
    }
  }
})

// 在 Trix 编辑器初始化时添加居中按钮
document.addEventListener('trix-initialize', function(event) {
  const { toolbarElement } = event.target

  // 检查工具栏是否已经添加了居中按钮
  if (toolbarElement && !toolbarElement.querySelector('[data-trix-attribute="textAlignCenter"]')) {
    // 找到工具栏中的第一个按钮组（文本格式按钮组）
    const buttonGroup = toolbarElement.querySelector('.trix-button-group')

    if (buttonGroup) {
      // 创建居中对齐按钮
      const centerButton = document.createElement('button')
      centerButton.type = 'button'
      centerButton.className = 'trix-button trix-button--icon trix-button--icon-center'
      centerButton.setAttribute('data-trix-attribute', 'textAlignCenter')
      centerButton.setAttribute('title', '居中对齐')
      centerButton.setAttribute('tabindex', '-1')
      centerButton.textContent = '居中'

      // 将按钮插入到斜体按钮之后
      const italicButton = buttonGroup.querySelector('[data-trix-attribute="italic"]')
      if (italicButton && italicButton.nextSibling) {
        buttonGroup.insertBefore(centerButton, italicButton.nextSibling)
      } else {
        buttonGroup.appendChild(centerButton)
      }
    }
  }
})
